import { CreateReducer } from "../../shared/utils/createReducer";
import {
  IN_APP_NOTIFICATIONS_MARK_ALL_READ,
  IN_APP_NOTIFICATIONS_MARK_READ,
  IN_APP_NOTIFICATIONS_MERGE,
  IN_APP_NOTIFICATIONS_PUSH,
} from "../definitions/inAppNotificationConstants";
import {
  MarkAllInAppNotificationsReadAction,
  MarkInAppNotificationReadAction,
  MergeInAppNotificationsAction,
  PushInAppNotificationAction,
} from "../actions/inAppNotificationActions";
import { InAppNotification } from "../../types/inAppNotification";

export interface InAppNotificationState {
  items: InAppNotification[];
  unreadCount: number;
}

const initState: InAppNotificationState = {
  items: [],
  unreadCount: 0,
};

function recomputeUnread(items: InAppNotification[]): number {
  return items.filter((n) => !n.read_at).length;
}

const inAppNotificationReducer = CreateReducer(initState, {
  [IN_APP_NOTIFICATIONS_MERGE](
    _state: InAppNotificationState,
    action: MergeInAppNotificationsAction
  ): InAppNotificationState {
    const { notifications, unreadCount } = action.payload;
    return {
      items: notifications,
      unreadCount,
    };
  },
  [IN_APP_NOTIFICATIONS_PUSH](
    state: InAppNotificationState,
    action: PushInAppNotificationAction
  ): InAppNotificationState {
    const n = action.payload.notification;
    const withoutDup = state.items.filter((x) => x.id !== n.id);
    const items = [n, ...withoutDup].slice(0, 100);
    return {
      items,
      unreadCount: recomputeUnread(items),
    };
  },
  [IN_APP_NOTIFICATIONS_MARK_READ](
    state: InAppNotificationState,
    action: MarkInAppNotificationReadAction
  ): InAppNotificationState {
    const id = action.payload.id;
    const now = new Date().toISOString();
    const items = state.items.map((n) =>
      n.id === id && !n.read_at ? { ...n, read_at: now } : n
    );
    return {
      items,
      unreadCount: recomputeUnread(items),
    };
  },
  [IN_APP_NOTIFICATIONS_MARK_ALL_READ](
    state: InAppNotificationState,
    _action: MarkAllInAppNotificationsReadAction
  ): InAppNotificationState {
    const now = new Date().toISOString();
    const items = state.items.map((n) => ({
      ...n,
      read_at: n.read_at ?? now,
    }));
    return {
      items,
      unreadCount: 0,
    };
  },
});

export default inAppNotificationReducer;
